export interface ICookieOptions {
  domain?: string;
  path?: string;
  expires?: string;
}

function createCookie(name: string, value: string, options?: ICookieOptions) {
  let cookieString = `${name}=${value};`;

  if (options) {
    Object.entries(options)
      .filter(([, v]) => v !== undefined)
      .forEach(([k, v]) => {
        cookieString += `${k}=${v};`;
      });
  }

  document.cookie = cookieString;
}

function getCookies() {
  const cookies: Record<string, string> = {};

  document.cookie.split(';').forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    cookies[name] = value;
  });

  return cookies;
}

function getCookie(name: string) {
  const cookies = getCookies();
  return cookies[name];
}

/**
 * `domain: null` apaga um cookie host-only (gravado sem `domain`), necessário fora de acerto.com.br.
 */
function deleteCookie(name: string, domain: string | null = '.acerto.com.br') {
  const domainAttr = domain ? `domain=${domain};` : '';
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;${domainAttr}`;
}

export default {
  createCookie,
  getCookies,
  getCookie,
  deleteCookie,
};
